module.exports = __webpack_public_path__ + "img/img_dy.3ed35542.png";